import { c as _c } from "react/compiler-runtime";
import { BodyLong } from "@navikt/ds-react";
export const VurderingIkkeAktuell = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <BodyLong>NAV vurderer at aktivitetsplikten ikke er aktuell for deg. Dette kan blant annet gjelde hvis du mottar en annen ytelse enn sykepenger.</BodyLong>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};